<template>
  <b-container fluid v-if="shipping.id">
    <!-- ONGOING -->
    <b-row v-if="shipping.status !== null && shipping.status !== 'DRAFT' && shipping.status !== 'READY' && shipping.status !== 'DELIVERED' && shipping.status !== 'TOBERETURNED' && shipping.status !== 'RETURNED' && shipping.status !== 'CANCELED' && !isScheduled">
      <b-col id="shipping-form" v-if="shippingTypes.length > 0">
        <b-card class="shipping-item" :class="shipping.status ? shipping.status.toLowerCase() : ''">
          <span style="position:absolute; top: 0; right: 0; padding: 0 10px" v-if="isNextDay" class="bg-dark text-light"><small><translate>Next Day</translate></small></span>
          <span style="position:absolute; top: 0; left: 0; padding: 0 10px" v-if="isPickup" class="bg-success text-light"><small><translate>PICKUP</translate></small></span>
          <span style="position:absolute; top: 0; left: 0; padding: 0 10px" v-if="isReturn" class="bg-success text-light"><small><translate>RETURN</translate></small></span>
          <b-row>
            <b-col cols="6" style="padding-left:35px">
              <strong style="font-size: 18px">#{{shipping.id | uuid}}</strong>
            </b-col>
            <b-col cols="6" class="text-right">
              {{moment.utc(shipping.created_at).tz($tz).format('L LT')}}
            </b-col>
            <b-col cols="12" v-if="(shipping.status === 'DRAFT' || shipping.status === 'READY' || shipping.status === 'WAITING' || shipping.status === 'CONFIRMED' || shipping.status === 'ATPICKUPPOINT') && !shipping.fields_revision" class="mt-2">
              <b-button size="sm" style="padding: 0.1rem 1rem;" @click.stop.prevent="getShippingLabel" :title="$gettext('Get shipping PDF label')"><font-awesome-icon icon="file-pdf" size="1x" />&nbsp;&nbsp;<translate>Shipping label</translate></b-button>
            </b-col>
            <b-col cols="12" class="shipping-status" style="margin-top:20px; margin-bottom: 20px;">

              <shipping-statuses :shipping="shipping" />

            </b-col>
            <b-col cols="12" class="shipping-origin mb-3">
              <h5 class="shipping-contact">{{shipping.from_contact}}</h5>
              <p><span class="shipping-address">{{shipping.address_from.formatted_address}}{{shipping.from_extra && shipping.from_extra.trim() !== '' ? ' (' + shipping.from_extra.trim() + ')' : ''}}</span>
                <span v-if="shipping.from_email"><br>{{shipping.from_email}}</span>
                <span v-if="shipping.from_phone"><br>{{shipping.from_phone}}</span>
              </p>
            </b-col>
            <b-col cols="12" class="shipping-destination">
              <h5 class="shipping-contact">{{shipping.to_contact}}</h5>
              <p><span class="shipping-address">{{shipping.address_to.formatted_address}}{{shipping.to_extra && shipping.to_extra.trim() !== '' ? ' (' + shipping.to_extra.trim() + ')' : ''}}</span>
                <span v-if="shipping.to_email"><br>{{shipping.to_email}}</span>
                <span v-if="shipping.to_phone"><br>{{shipping.to_phone}}</span>
              </p>
            </b-col>
            <b-col cols="12" v-if="isPickup ||isReturn" class="mt-2">
              <div>
                <b-button size="sm" variant="success" style="padding: 0.1rem 1rem;" v-b-modal.modalPickedupShippings @click.prevent.stop="getPickedupShippings(shipping.id)">
                  <font-awesome-icon :icon="['far', 'eye']" size="1x" style="font-size: 16px;vertical-align: middle" />
                  <translate>Picked up shippings</translate>
                </b-button>
              </div>
            </b-col>
            <b-col cols="12" class="shipping-actions text-right">
              <div v-if="shipping.external_code" v-translate="{externalCode: shipping.external_code}">
                Code: <strong>%{externalCode}</strong>
              </div>
              <div v-if="shipping.external_order_id" v-translate="{externalOrderId: shipping.external_order_id}">
                Order: <strong>%{externalOrderId}</strong>
              </div>
              <div v-if="shipping.secret_code" v-translate="{secretCode: shipping.secret_code}">
                Secret Code: <strong>%{secretCode}</strong>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="items.length > 0">
          <h5 v-translate>Shipping Items</h5>
          <b-row v-for="(item, index) in items" :key="index">
            <b-col cols="12">
              <hr>
            </b-col>
            <b-col cols="10">
              - {{item.description}}
            </b-col>
            <b-col>
              {{item.quantity}} u.
            </b-col>
            <b-col cols="12" v-if="item.serial_number">
              <small v-translate="{serialNumbers: item.serial_number}">-- Serial Numbers: %{serialNumbers}</small>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="shipping-item" v-if="shipping.description || shipping.instructions || shipping.from_meta || shipping.to_meta">
          <b-form-row>
            <b-col cols="12" v-if="shipping.description" class="mb-3">
              <h5 v-translate>Shipping Description</h5>
              <p v-html="$options.filters.brize(shipping.description)"></p>
            </b-col>
            <b-col cols="12" v-if="shipping.instructions" class="mb-3">
              <h5 v-translate>General Instructions</h5>
              <p v-html="$options.filters.brize(shipping.instructions)"></p>
            </b-col>
            <b-col cols="12" v-if="shipping.from_meta" class="mb-3">
              <h5 v-translate>Instructions on Origin</h5>
              <p v-html="$options.filters.brize(shipping.from_meta)"></p>
            </b-col>
            <b-col cols="12" v-if="shipping.to_meta" class="mb-3">
              <h5 v-translate>Instructions on Destination</h5>
              <p v-html="$options.filters.brize(shipping.to_meta)"></p>
            </b-col>
          </b-form-row>
        </b-card>
        <b-card v-if="shipping.courier !== null">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="3">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle profile-image" alt="img" :style="'width: 100%; height: auto; background-image: url(' + (shipping.courier.profile_picture || 'https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm') + ')'" />
                </b-col>
                <b-col class="align-self-center">
                  <h5>{{shipping.courier.name}} <small v-if="shipping.courier.courier_available && shipping.courier.courier_available.user.tin"><small>({{ shipping.courier.courier_available.user.tin }})</small></small></h5>
                  <strong class="plate" v-if="shipping.courier.courier_available && shipping.courier.courier_available.vehicle && shipping.courier.courier_available.vehicle.plate_number">{{ shipping.courier.courier_available.vehicle.plate_number }}</strong>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="shipping-events" v-if="shipping.shipping_event_history.length > 0">

          <h4 v-translate>Events History</h4>
          <ul class="p-0">
            <li class="row">
              <b-col cols="7">
                <dl>
                  <dt v-translate>Event</dt>
                </dl>
              </b-col>
              <b-col cols="5">
              <dl>
                <dt v-translate>Date</dt>
              </dl>
              </b-col>
            </li>
            <li class="row" v-for="event in shipping.shipping_event_history">
              <b-col cols="7">
                <font-awesome-icon icon="phone" v-if="event.data.phone" />
                {{ event.data.phone }}
              </b-col>
              <b-col cols="5">
                {{moment.utc(event.created_at).tz($tz).format('L LT')}}
                <b-button
                  v-b-modal.modalStaticTrackingMap
                  style="width: 1.5rem;
                  height: 1.5rem;
                  display: inline-block;
                  padding: 0;"
                  size="sm"
                  @click.stop="staticTrackingCoords = [{lat: event.lat, lng: event.lng}]"
                >
                  <font-awesome-icon icon="map-marker-alt" size="1x" style="vertical-align: middle" />
                </b-button>
              </b-col>
            </li>
          </ul>
          <b-modal size="lg" id="modalStaticTrackingMap" ref="modalStaticTrackingMap" hide-footer hide-header @hide="staticTrackingCoords = []">
            <mapbox-static-map :markers="staticTrackingCoords" :size="[700, 700]"></mapbox-static-map>
          </b-modal>
          <!-- <shipping-status-history :shipping="shipping" /> -->


        </b-card>

        <b-card class="shipping-statuses">

          <shipping-status-history :shipping="shipping" with-elapsed />

        </b-card>

      </b-col>
      <b-col class="d-none d-md-block" id="shipping-map">
        <leaflet-map ref="fullMap" :geolocate="false" :fit-once="true" style="height: 100%" />
      </b-col>
    </b-row>
    <!-- /ONGOING -->
    <!-- DELIVERED || scheduled -->
    <b-row v-else>
      <b-container v-if="shippingTypes && shippingTypes.length > 0">
        <b-alert variant="danger" :show="shipping.fields_revision_data &&
          (shipping.fields_revision_data.from || shipping.fields_revision_data.to) &&
          (typeof shipping.fields_revision_data.from === 'string' || typeof shipping.fields_revision_data.to === 'string')
          " >
          <h2><font-awesome-icon icon="exclamation-triangle" size="1x" /> <translate>Warning</translate></h2>
          <p v-translate>At least one address of your shipping couldn't be recognized, please review it below.</p>
        </b-alert>
        <b-alert variant="warning" :show="shipping.fields_revision_data &&
        (shipping.fields_revision_data.from || shipping.fields_revision_data.to) &&
        (typeof shipping.fields_revision_data.from === 'object' || typeof shipping.fields_revision_data.to === 'object')" >
          <h2><font-awesome-icon icon="exclamation-triangle" size="1x" /> <translate>Warning</translate></h2>
          <p v-translate>At least one address of your shipping has multiple possible options, please review it below.</p>
        </b-alert>
        <b-row>
          <b-col lg="6">
            <b-card class="shipping-item" :class="shipping.status ? shipping.status.toLowerCase() : ''">
              <span style="position:absolute; top: 0; right: 0; padding: 0 10px" v-if="isNextDay" class="bg-dark text-light"><small><translate>Next Day</translate></small></span>
              <span style="position:absolute; top: 0; left: 0; padding: 0 10px" v-if="isPickup" class="bg-success text-light"><small><translate>PICKUP</translate></small></span>
              <span style="position:absolute; top: 0; left: 0; padding: 0 10px" v-if="isReturn" class="bg-success text-light"><small><translate>RETURN</translate></small></span>
              <b-row>
                <b-col cols="7" class="shipping-status" style="margin-bottom: 10px;">

                  <shipping-statuses :shipping="shipping" />

                </b-col>
                <b-col cols="5" class="text-right">s
                  {{moment.utc(shipping.created_at).tz($tz).format('L LT')}}
                </b-col>
                <b-col cols="6" style="padding-left:35px">
                  <strong>#{{shipping.id | uuid}}</strong>
                </b-col>
                <b-col cols="6" class="text-right" v-show="totalTime && this.shipping.status !== 'CANCELED'">
                  <strong><font-awesome-icon :icon="['far', 'clock']" size="1x" /> {{totalTime}}</strong>
                </b-col>
                <b-col cols="12" v-if="markers.length !== 0">
                  <mapbox-static-map :google-api-key="this.$appConfig.maps.api_key" :format="format" :markers="markers" :zoom="-1" :center="center" :size="size" :type="type" :language="language" class="card-img-top d-noneX d-lg-blockX" :customStyle="this.$appConfig.maps.staticMapStyle" style="margin: 20px 0"></mapbox-static-map>
                </b-col>
                <b-col cols="12" v-if="(shipping.status === 'DRAFT' || shipping.status === 'READY' || shipping.status === 'WAITING' || shipping.status === 'CONFIRMED' || shipping.status === 'ATPICKUPPOINT') && !shipping.fields_revision" class="mt-2 text-right">
                  <b-button size="sm" style="padding: 0.1rem 1rem;" @click.stop.prevent="getShippingLabel" :title="$gettext('Get shipping PDF label')"><font-awesome-icon icon="file-pdf" size="1x" />&nbsp;&nbsp;<translate>Shipping label</translate></b-button>
                </b-col>
                <b-col cols="6" v-translate v-show="this.shipping.status === 'DELIVERED'">
                  Total
                </b-col>
                <b-col cols="6" class="text-right" v-show="this.shipping.status === 'DELIVERED'">
                  {{shipping.price_formatted}}
                </b-col>
              </b-row>
            </b-card>
            <b-card v-if="shipping.courier">
              <b-row>
                <b-col cols="12">
                  <b-row>
                    <b-col cols="3">
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle profile-image" alt="img" :style="'width: 100%; height: auto; background-image: url(' + (shipping.courier.profile_picture || 'https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm') + ')'" />
                    </b-col>
                    <b-col cols="5" class="align-self-center">
                      <h5>{{shipping.courier.name}}</h5>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card class="shipping-item" :class="shipping.status ? shipping.status.toLowerCase() : ''">
              <b-col cols="12" class="shipping-origin mb-3">
                <h5 class="shipping-contact" style="font-size:18px;line-height:1.4">{{shipping.from_contact}}</h5>
                <h5 class="text-secondary" v-translate="{pickedupAt: moment.utc(pickedupAt).tz($tz).format('L LT')}" v-show="pickedupAt && shipping.status === 'DELIVERED'">Picked Up: %{pickedupAt}</h5>
                <p>
                  <span v-if="(!shipping.fields_revision || shipping.fields_revision === false) || !shipping.fields_revision_data.from || typeof shipping.fields_revision_data.from === 'object'">
                    <span
                      class="shipping-address"
                      :class="shipping.fields_revision_data &&
                        shipping.fields_revision_data.from &&
                        typeof shipping.fields_revision_data.from === 'object' ? 'text-warning' : ''"
                      :title="shipping.address_from.formatted_address"><font-awesome-icon v-if="shipping.fields_revision_data &&
                        shipping.fields_revision_data.from &&
                        typeof shipping.fields_revision_data.from === 'object'" icon="exclamation-triangle" size="1x" /> {{shipping.address_from.formatted_address}}{{shipping.from_extra && shipping.from_extra.trim() !== '' ? ' (' + shipping.from_extra.trim() + ')' : ''}}</span>
                  </span>
                  <span v-if="shipping.fields_revision_data !== null && typeof shipping.fields_revision_data.from === 'string'">
                    <span class="shipping-address text-danger" :title="shipping.fields_revision_data.from"><font-awesome-icon icon="exclamation-triangle" size="1x" /> {{shipping.fields_revision_data.from}}</span>
                  </span>
                  <b-button variant="primary" class="text-light" v-if="shipping.fields_revision_data && shipping.fields_revision_data.from" size="sm" @click.prevent v-b-modal.modalFixAddressFrom v-translate>Review Address</b-button>
                  <span v-if="shipping.from_email"><br>{{shipping.from_email}}</span>
                  <span v-if="shipping.from_phone"><br>{{shipping.from_phone}}</span>
                </p>
              </b-col>
              <b-col cols="12" class="shipping-destination mb-3">
                <h5 class="shipping-contact" style="font-size: 18px;line-height:1.4">{{shipping.to_contact}}</h5>
                <h5 class="text-primary" v-translate="{deliveredAt: moment.utc(deliveredAt).tz($tz).format('L LT')}" v-show="deliveredAt && shipping.status === 'DELIVERED'">Delivered: %{deliveredAt}</h5>
                <p>
                  <span v-if="(!shipping.fields_revision || shipping.fields_revision === false) || !shipping.fields_revision_data.to || typeof shipping.fields_revision_data.to === 'object'">
                    <span
                      class="shipping-address"
                      :class="shipping.fields_revision_data &&
                        shipping.fields_revision_data.to &&
                        typeof shipping.fields_revision_data.to === 'object' ? 'text-warning' : ''"
                      :title="shipping.address_to.formatted_address"><font-awesome-icon v-if="shipping.fields_revision_data &&
                        shipping.fields_revision_data.to &&
                        typeof shipping.fields_revision_data.to === 'object'" icon="exclamation-triangle" size="1x" /> {{shipping.address_to.formatted_address}}</span>
                  </span>
                  <span v-if="shipping.fields_revision_data !== null && typeof shipping.fields_revision_data.to === 'string'">
                    <span class="shipping-address text-danger" :title="shipping.fields_revision_data.to"><font-awesome-icon icon="exclamation-triangle" size="1x" /> {{shipping.fields_revision_data.to}}{{shipping.to_extra && shipping.to_extra.trim() !== '' ? ' (' + shipping.to_extra.trim() + ')' : ''}}</span>
                  </span>
                  <b-button variant="primary" class="text-light" v-if="shipping.fields_revision_data && shipping.fields_revision_data.to" size="sm" @click.prevent v-b-modal.modalFixAddressTo v-translate>Review Address</b-button>
                  <span v-if="shipping.to_email"><br>{{shipping.to_email}}</span>
                  <span v-if="shipping.to_phone"><br>{{shipping.to_phone}}</span>
                </p>
                <hr />
                <div v-if="shipping.external_code" v-translate="{externalCode: shipping.external_code}">
                  Code: <strong>%{externalCode}</strong>
                </div>
                <div v-if="shipping.external_order_id" v-translate="{externalOrderId: shipping.external_order_id}">
                  Order: <strong>%{externalOrderId}</strong>
                </div>
                <div v-if="shipping.secret_code" v-translate="{secretCode: shipping.secret_code}">
                  Secret Code: <strong>%{secretCode}</strong>
                </div>
                <div v-if="isPickup || isReturn" class="mt-2">
                  <b-button size="sm" variant="success" style="padding: 0.1rem 1rem;" v-b-modal.modalPickedupShippings @click.prevent.stop="getPickedupShippings(shipping.id)">
                    <font-awesome-icon :icon="['far', 'eye']" size="1x" style="font-size: 16px;vertical-align: middle" />
                    <translate>Picked up shippings</translate>
                  </b-button>
                </div>
              </b-col>

              <b-alert class="mt-3" :show="shipping.receiver_first_name ? true : false">
                <b-row class="mb-3" v-if="shipping.photos.length > 0">
                  <b-col class="text-center" v-for="(photo, index) in shipping.photos" :key="index" v-if="shipping.photos[index].type !== 'SIGNATURE'">
                    <a href="#" v-b-modal.modalShowShippingPicture @click.prevent="currentPicture = photo.full_path"><img :src="photo.full_path" alt="" style="height:150px; width:auto"></a><br>{{statusStringsByType[photo.type]}}
                  </b-col>
                </b-row>
                <hr v-if="shipping.photos.length > 1">
                <b-row>
                  <b-col cols="3" v-if="(shipping.photos.length > 0 || shipping.receiver_signature) && (shipping.receiver_signature || (shipping.photos.find(x => x.type === 'SIGNATURE') && shipping.photos.find(x => x.type === 'SIGNATURE').full_path))">
                    <a class="mr-2" href="#" v-b-modal.modalShowShippingPicture @click.prevent="currentPicture = shipping.receiver_signature || (shipping.photos.find(x => x.type === 'SIGNATURE') && shipping.photos.find(x => x.type === 'SIGNATURE').full_path)"><img :src="shipping.receiver_signature || shipping.photos.find(x => x.type === 'SIGNATURE').full_path" alt="" style="height:100px; width: auto"></a>
                  </b-col>
                  <b-col cols="9">
                    <ul>
                      <li v-show="shipping.receiver_first_name"><translate>Receiver</translate>: {{shipping.receiver_first_name}} {{shipping.receiver_last_name}}</li>
                      <li v-show="shipping.receiver_address_street"><translate>Address</translate>: {{shipping.receiver_address_street}} {{shipping.receiver_address_number}}{{shipping.receiver_address_extra ? ', ' + shipping.receiver_address_extra : ''}}</li>
                      <li v-show="shipping.receiver_phone"><translate>Phone</translate>: {{shipping.receiver_phone}}</li>
                      <li v-show="shipping.receiver_comments"><translate>Comments</translate>: {{shipping.receiver_comments}}</li>
                      <li v-show="shipping.status_history[0].details && shipping.status_history[0].details.receiver_uid"><translate>Document</translate>: {{shipping.status_history[0].details && shipping.status_history[0].details.receiver_uid ? shipping.status_history[0].details.receiver_uid : ''}}</li>
                      <li v-show="shipping.status_history[0].details && shipping.status_history[0].details.receiver_scanned_info"><translate>Document Validation</translate>: {{shipping.status_history[0].details && shipping.status_history[0].details.receiver_scanned_info ? shipping.status_history[0].details.receiver_scanned_info : ''}}</li>
                    </ul>
                  </b-col>
                </b-row>
              </b-alert>

            </b-card>
            <b-card v-if="items.length > 0">
              <h5 v-translate>Shipping Items</h5>
              <b-row v-for="(item, index) in items" :key="index">
                <b-col cols="12">
                  <hr>
                </b-col>
                <b-col cols="10">
                  - {{item.description}}
                </b-col>
                <b-col>
                  {{item.quantity}} u.
                </b-col>
                <b-col cols="12" v-if="item.serial_number">
                  <small v-translate="{serialNumbers: item.serial_number}">-- Serial Numbers: %{serialNumbers}</small>
                </b-col>
              </b-row>
            </b-card>
            <b-card class="shipping-item" v-if="shipping.description || shipping.instructions || shipping.from_meta || shipping.to_meta">
              <b-form-row>
                <b-col cols="12" v-if="shipping.description" class="mb-3">
                  <h5 v-translate>Shipping Description</h5>
                  <p v-html="$options.filters.brize(shipping.description)"></p>
                </b-col>
                <b-col cols="12" v-if="shipping.instructions" class="mb-3">
                  <h5 v-translate>General Instructions</h5>
                  <p v-html="$options.filters.brize(shipping.instructions)"></p>
                </b-col>
                <b-col cols="12" v-if="shipping.from_meta" class="mb-3">
                  <h5 v-translate>Instructions on Origin</h5>
                  <p v-html="$options.filters.brize(shipping.from_meta)"></p>
                </b-col>
                <b-col cols="12" v-if="shipping.to_meta" class="mb-3">
                  <h5 v-translate>Instructions on Destination</h5>
                  <p v-html="$options.filters.brize(shipping.to_meta)"></p>
                </b-col>
              </b-form-row>
            </b-card>

            <b-card class="shipping-statuses">

              <shipping-status-history :shipping="shipping" with-elapsed />

            </b-card>

          </b-col>
        </b-row>
      </b-container>
    </b-row>

    <b-modal id="modalShowShippingPicture" ref="modalShowShippingPicture" size="lg" :hide-footer="true" @hidden="currentPicture = ''">
      <div slot="modal-title" v-translate>View picture</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <div class="w-100">
        <img :src="currentPicture" alt="" class="w-100">
      </div>
    </b-modal>

    <b-modal id="modalFixAddressFrom" ref="modalFixAddressFrom" :hide-footer="true" @shown="clearTimeout" @hide="restartTimeout">
      <div slot="modal-title" v-translate>Review FROM Address</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <fix-addresses-form :theShipping="shipping" type="from" @success="closeModal('modalFixAddressFrom')" @cancel="closeModal('modalFixAddressFrom')" />
    </b-modal>

    <b-modal id="modalFixAddressTo" ref="modalFixAddressTo" :hide-footer="true" @shown="clearTimeout" @hide="restartTimeout">
      <div slot="modal-title" v-translate>Review TO Address</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <fix-addresses-form :theShipping="shipping" type="to" @success="closeModal('modalFixAddressTo')" @cancel="closeModal('modalFixAddressTo')" />
    </b-modal>

    <b-modal size="lg" id="modalPickedupShippings" ref="modalPickedupShippings" :hide-footer="true" @hide="pickedupShippings = [];">
      <div slot="modal-title" v-translate>Picked Up Shippings</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <picked-up-list :pickupShipping="shipping" :shippings="pickedupShippings" />
    </b-modal>

  </b-container>
</template>
<script>
import constants from '@/common/constants'
import AddressMixins from '@/mixins/address.mixin.js'
import { mapGetters } from 'vuex'
import LeafletMap from '@/components/LeafletMap'
import MapboxStaticMap from '@/components/MapboxStaticMap'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import ShippingStatuses from '@/components/ShippingStatuses'
import ShippingStatusHistory from '@/components/ShippingStatusHistory'
import PlacePicker from '@/components/PlacePicker'
import PickedUpList from '@/components/PickedUpList'
import FixAddressesForm from '@/components/FixAddressesForm'

export default {
  name: 'ShippingPage',
  title() {
    return this.$gettext('Shipping') + ' #' + this.$options.filters.uuid(this.$route.params.id)
  },
  components: {
    MapboxStaticMap,
    LeafletMap,
    AddressAutocomplete,
    ShippingStatuses,
    ShippingStatusHistory,
    PlacePicker,
    PickedUpList,
    FixAddressesForm
  },
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      viewPhone: null,
      vehicleTypes: [],
      tracking: {},
      type: 'roadmap',
      size: [600, 300],
      config: this.$appConfig,
      apiKey: this.$appConfig.maps.api_key, // required
      zoom: 15, // required
      center: '',
      format: 'png',
      language: 'es',
      mapStyle: this.$appConfig.maps.staticMapStyle,
      markers: [],
      fitted: false,
      step: null,
      pickedupAt: '',
      deliveredAt: '',
      totalTime: null,
      validFrom: false,
      validTo: false,
      pickedupShippings: [],
      pickedupShippingsFields: [
        {
          key: 'id',
          label: this.$gettext('ID')
        },
        {
          key: 'status',
          label: this.$gettext('Status')
        },
        {
          key: 'size_id',
          label: this.$gettext('Size')
        },
        {
          key: 'shipping_type_id',
          label: this.$gettext('Type')
        }
      ],
      shippingTypes: [],
      items: [],
      shipping: {},
      timeout: null,
      staticTrackingCoords: [],
      statusStringsByType: {}
    }
  },
  computed: {
    isScheduled() {
      return this.shipping.scheduled_date && this.moment.utc(this.shipping.scheduled_date) > this.moment().utc()
    },
    isNextDay() {
      return this.shippingTypes.findIndex(x => x.name === 'next_day') !== -1 && this.shipping.shipping_type_id === this.shippingTypes.find(x => x.name === 'next_day').id
    },
    isPickup() {
      return this.shippingTypes.findIndex(x => x.name === 'pickup') !== -1 && this.shipping.shipping_type_id === this.shippingTypes.find(x => x.name === 'pickup').id
    },
    isReturn() {
      return this.shippingTypes.findIndex(x => x.name === 'return') !== -1 && this.shipping.shipping_type_id === this.shippingTypes.find(x => x.name === 'return').id
    },
    ...mapGetters([
      // 'shipping',
      'currentUser',
      'comments',
      'isAuthenticated'
    ])
  },
  mixins: [constants, AddressMixins],
  created() {
    this.fetchShippingSizes()
    this.fetchShippingTypes()
    this.fetchVehicleTypes()
  },
  mounted() {
    if (this.$route.query.created) {
      this.showAlert()
      this.$router.push({ name: 'shipping', params: { id: this.$route.params.id } })
    }
    this.fetchShipping()
  },
  beforeDestroy() {
    this.clearTimeout()
  },
  methods: {
    fetchShipping() {
      this.clearTimeout()
      if (this.$route.query.created) {
        this.showAlert()
        this.$router.push({ name: 'shipping', params: { id: this.$route.params.id } })
      }
      let params = {
        includes: [
          'courier.courier_available.vehicle',
          'courier.courier_available.user',
          'company',
          'status_history',
          'notifications_close_to_arrive',
          'previousShipping',
          'followingShippings',
          'items',
          'shippingEventHistory',
          'shipping_type'
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/shippings/' + this.$route.params.id, { params: params })
        .then(response => {
          this.shipping = response.body

          this.statusStringsByType = this.shipping.shipping_type.name !== 'reverse' ? this.statusStrings.normal : this.statusStrings.reverse

          if (this.shipping.items && this.shipping.items.length > 0) {
            this.items = this.shipping.items.map(x => {
              if (x.item) {
                x.item.quantity = x.item.quantity || 1
                x.item.description = x.item.description || x.item.name || this.$gettext('No item description')
                x.item.serial_number = x.item.serial_number && x.item.serial_number.length > 0 ? x.item.serial_number.join(', ') : null
              } else {
                x.quantity = x.quantity || 1
                x.description = x.description || x.name || this.$gettext('No item description')
                x.serial_number = x.serial_number && x.serial_number.length > 0 ? x.serial_number.join(', ') : null
              }

              return {
                description: x.description || x.item.description || this.$gettext('No item description'),
                quantity: x.quantity || x.item.quantity || 1,
                serial_number: x.serial_number || (x.item && x.item.serial_number ? x.item.serial_number : null)
              }
            })
          } else if (this.shipping.meta && this.shipping.meta.items && this.shipping.meta.items.length > 0) {
            this.items = this.shipping.meta.items.map(x => {
              if (x.item) {
                x.item.quantity = x.item.quantity || 1
                x.item.description = x.item.description || x.item.name || this.$gettext('No item description')
                x.item.serial_number = x.item.serialNumbers && x.item.serialNumbers.length > 0 ? x.item.serialNumbers.join(', ') : null
              } else {
                x.quantity = x.quantity || 1
                x.description = x.description || x.name || this.$gettext('No item description')
                x.serial_number = x.serialNumbers && x.serialNumbers.length > 0 ? x.serialNumbers.join(', ') : null
              }

              return {
                description: x.description || x.item.description || this.$gettext('No item description'),
                quantity: x.quantity || x.item.quantity || 1,
                serial_number: x.serial_number || (x.item && x.item.serial_number ? x.item.serial_number : null)
              }
            })
          } else {
            this.items = []
          }

          if (this.shipping.status === 'INCIDENCE') {
            for (let i = 0; i < this.shipping.status_history.length; i++) {
              if (this.shipping.status_history[i].details && (this.shipping.status_history[i].details.reason === 'absent_recipient' || this.shipping.status_history[i].details.reason === 'absent_client')) {
                this.visits++
              }
            }
          }

          this.checkTracking()

          if (this.shipping.status !== 'DELIVERED' && this.shipping.status !== 'CANCELED' && this.shipping.status !== 'RETURNED') {
            this.timeout = setTimeout(function () {
              this.fetchShipping()
            }.bind(this), 15000)
          } else {
            this.clearTimeout()
          }
        })
    },
    clearTimeout() {
      clearTimeout(this.timeout)
      this.timeout = null // just in case
    },
    restartTimeout() {
      this.fetchShipping()
    },
    fetchVehicleTypes() {
      this.$http.get(this.$appConfig.api.baseUrl + 'vehicle-types')
        .then(response => {
          this.vehicleTypes = response.body.data
        })
    },
    checkTracking() {
      let icon

      if (this.shipping.status !== 'DELIVERED' && this.shipping.status !== 'CANCELED' && this.shipping.status !== 'RETURNED') {
        if (this.shipping.courier && this.shipping.courier.courier_available) {
          icon = this.$appConfig.staticBaseUrl + 'static/img/ic-map-' + this.vehicleTypes.find(x => x.id === this.shipping.courier.courier_available.vehicle_type_id).name.toLowerCase() + '-blue.svg'
        }

        if (!this.isScheduled && this.shipping.status !== 'DRAFT' && this.shipping.status !== 'READY' && this.shipping.status !== 'TOBERETURNED') {
          let noCourierYet = this.markers.length === 2 || false

          this.markers = []
          this.markers.push({
            id: '0',
            lat: this.shipping.address_from.lat,
            lng: this.shipping.address_from.lng,
            icon: this.$appConfig.staticBaseUrl + 'static/img/ic_origin_on.svg',
            x: 10,
            y: 10,
            infoText: this.$gettext('Origin'),
            tooltip: true
          })
          this.markers.push({
            id: '1',
            lat: this.shipping.address_to.lat,
            lng: this.shipping.address_to.lng,
            icon: this.$appConfig.staticBaseUrl + 'static/img/ic_destination_on.svg',
            x: 10,
            y: 10,
            infoText: this.$gettext('Destination'),
            tooltip: true
          })

          if (this.shipping.current_tracking !== null) {
            if (noCourierYet) {
              this.fitted = false
            }
            this.markers.push({
              id: '2',
              lat: this.shipping.current_tracking.lat,
              lng: this.shipping.current_tracking.lng,
              icon: icon,
              x: 25,
              y: 25,
              infoText: this.courierI18n,
              tooltip: true
            })
          }

          this.updateMarkers()
        } else {
          this.markers = [{
            label: 'A',
            color: 'red',
            icon: this.$appConfig.staticBaseUrl + 'static/img/ico-from_green.png',
            lat: this.shipping.address_from ? this.shipping.address_from.lat : null,
            lng: this.shipping.address_from ? this.shipping.address_from.lng : null,
            size: 'normal'
          },
          {
            label: 'B',
            color: 'green',
            icon: this.$appConfig.staticBaseUrl + 'static/img/ico-to_blue.png',
            lat: this.shipping.address_to ? this.shipping.address_to.lat : null,
            lng: this.shipping.address_to ? this.shipping.address_to.lng : null,
            size: 'normal'
          }]
        }
      } else {
        this.markers = [{
          label: 'A',
          color: 'red',
          icon: this.$appConfig.staticBaseUrl + 'static/img/ico-from_green.png',
          lat: this.shipping.address_from ? this.shipping.address_from.lat : null,
          lng: this.shipping.address_from ? this.shipping.address_from.lng : null,
          size: 'normal'
        },
        {
          label: 'B',
          color: 'green',
          icon: this.$appConfig.staticBaseUrl + 'static/img/ico-to_blue.png',
          lat: this.shipping.address_to ? this.shipping.address_to.lat : null,
          lng: this.shipping.address_to ? this.shipping.address_to.lng : null,
          size: 'normal'
        }]
        for (let n = 0; n < this.shipping.status_history.length; n++) {
          if (this.shipping.status_history[n].status === 'INTRANSIT') {
            this.pickedupAt = this.shipping.status_history[n].created_at
          }
          if (this.shipping.status_history[n].status === 'DELIVERED') {
            this.deliveredAt = this.shipping.status_history[n].created_at
          }
        }
        const deliveredAtDate = new Date(Date.parse(this.deliveredAt.replace(/-/g, '/')))
        const pickedupAtDate = new Date(Date.parse(this.pickedupAt.replace(/-/g, '/')))
        const diffMs = (deliveredAtDate - pickedupAtDate)
        const diffDays = Math.floor(diffMs / 86400000)
        const diffHrs = Math.floor((diffMs % 86400000) / 3600000)
        const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000)
        this.totalTime = (diffDays > 0 ? diffDays + 'd ' : '') + (diffHrs > 0 ? diffHrs + 'h ' : '') + (diffMins > 0 ? diffMins + 'm ' : '0m')
      }
    },
    updateMarkers() {
      if (this.$refs.fullMap) {
        this.$refs.fullMap.addMarkers(this.markers)
        if (this.fitted === false) {
          this.$refs.fullMap.fitted = false
          this.fitted = true
        }
      } else {
        setTimeout(this.updateMarkers, 100)
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    getShippingLabel() {
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/' + this.shipping.id + '/label')
        .then(response => {
          let labelUrl = response.body.label
          window.open(labelUrl, 'label__' + this.shipping.id)
        })
    },
    getPickedupShippings(id) {
      let params = {
        limit: 500,
        filter_groups: [
          {
            filters: [
              ['pickup_shipping_id', 'eq', id]
            ]
          }
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/shippings', {params: params})
        .then(response => {
          this.pickedupShippings = response.body.data
        })
    },
    elapsedTime(from, to) {
      const deliveredAtDate = new Date(Date.parse(to.replace(/-/g, '/')))
      const pickedupAtDate = new Date(Date.parse(from.replace(/-/g, '/')))
      const diffMs = (deliveredAtDate - pickedupAtDate)
      const diffDays = Math.floor(diffMs / 86400000)
      const diffHrs = Math.floor((diffMs % 86400000) / 3600000)
      const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000)
      return (diffDays > 0 ? diffDays + 'd ' : '') + (diffHrs > 0 ? diffHrs + 'h ' : '') + (diffMins > 0 ? diffMins + 'm ' : '0m')
    }
  }
}

</script>
